import { render, staticRenderFns } from "./Faltante.vue?vue&type=template&id=4e35bde0&"
import script from "./Faltante.vue?vue&type=script&lang=js&"
export * from "./Faltante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports